import { TagChip } from '../TagChip'
import styles from './CaseStudyCard.module.scss'

type Props = {
  title: string
  company: string
  image: string
  tags: string[]
  href: string
}

export const CaseStudyCard: React.FC<Props> = ({ title, company, image, tags, href }) => {
  return (
    <a href={href} className={styles.main_container}>
      <img src={image} alt="" className={styles.case_study_card_image} />
      <div className={styles.case_study_card_text_container}>
        <p className={styles.case_study_card_title}>{title}</p>
        <p className={styles.case_study_card_company}>{company}</p>
      </div>
      <div className={styles.case_study_card_tag_container}>
        {tags.map((tag) => (
          <TagChip key={tag} tag={tag} />
        ))}
      </div>
    </a>
  )
}
